import React from 'react'
import { Link, Route } from 'react-router-dom'
import { Page_settings } from '../../config/page_settings'

class SidebarNavList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: -1,
      clicked: -1
    }
  }

  handleExpand(e, i, match) {
    e.preventDefault()

    this.setState(() => ({
      active: (this.state.active === i ? -1 : i),
      clicked: 1
    }))
  }

  render() {
    let label = this.props.data.label && <span className='label label-theme ml-5'>{this.props.data.label}</span>
    let badge = this.props.data.badge && <span className='badge pull-right'>{this.props.data.badge}</span>
    let title = this.props.data.title && <span>{this.props.data.title} {label}</span>
    let highlight = this.props.data.highlight && <i className='fa fa-paper-plane text-theme' />

    return (
      <Page_settings.Consumer>
        {({ toggleMobileSidebar }) => (
          <Route path={this.props.data.path} exact={this.props.data.exact} children={({ match }) => (
            <li className={(match ? 'active ' : '') + ((this.props.active || (this.props.clicked === -1 && match)) ? 'expand ' : 'closed ') + (this.props.data.children ? 'has-sub ' : 'no-has-sub')}>
              {this.props.data.children ? (
                <Link to={this.props.data.path} onClick={this.props.expand}> {badge} {title} {highlight}</Link>
              ) :
                this.props.data.url ? (
                  <Link to={{ pathname: this.props.data.url }}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      e.preventDefault(); // 기본 링크 동작 방지
                      window.open(this.props.data.url, '_blank'); // 새 탭에서 열기
                    }}>  {badge} {title} {highlight}</Link>
                ) :
                  (
                    <Link to={this.props.data.path} onClick={toggleMobileSidebar}>  {badge} {title} {highlight}</Link>
                  )}
              {this.props.data.children && (
                <ul className={'sub-menu ' + (((this.props.active || (this.props.clicked === -1 && match))) ? 'd-block ' : 'd-none')}>
                  {this.props.data.children && this.props.data.children.map((submenu, i) => (
                    <SidebarNavList
                      data={submenu}
                      key={i}
                      expand={(e) => this.handleExpand(e, i, match)}
                      active={i === this.state.active}
                      clicked={this.state.clicked}
                    />
                  ))}
                </ul>
              )}
            </li>
          )} />
        )}
      </Page_settings.Consumer>
    )
  }
}

export default SidebarNavList
